import { Sparkles } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { AdminCardPage } from '@/components/commons'
import { RELEASE_NOTES } from '@/constants/release-notes'
import { ROUTES } from '@/constants/routes'
import { formatLocalDate } from '@/utils/campaign-dates'

/** Novidades de cada versão, só informativo para quem tem acesso à Administração */
export const WhatsNewPage = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()

	return (
		<AdminCardPage
			icon={<Sparkles className="size-5" />}
			title={t('administration.whatsNew.title')}
			subtitle={t('administration.whatsNew.subtitle')}
			onBack={() => navigate(ROUTES.ADMINISTRATION.INDEX)}
		>
			<div className="mx-auto flex w-full max-w-3xl flex-col gap-6">
				{RELEASE_NOTES.map((release, index) => (
					<article
						key={release.version}
						className="rounded-lg border border-kaefer-light-silver bg-white p-5"
					>
						<header className="flex flex-wrap items-center gap-2">
							<h2 className="text-lg font-semibold text-kaefer-dark-grey">
								{t('administration.whatsNew.version', {
									version: release.version,
								})}
							</h2>
							{index === 0 && (
								<span className="rounded-full bg-kaefer-forest-green/15 px-2 py-0.5 text-xs font-semibold text-kaefer-forest-green">
									{t('administration.whatsNew.latest')}
								</span>
							)}
							<span className="text-sm text-muted-foreground">
								{formatLocalDate(`${release.date}T12:00:00`)}
							</span>
						</header>
						<p className="mt-2 text-sm text-kaefer-dark-grey">
							{release.summary}
						</p>

						<div className="mt-4 flex flex-col gap-4">
							{release.sections.map((section) => (
								<section key={section.title}>
									<h3 className="text-sm font-semibold text-kaefer-medium-grey">
										{section.title}
									</h3>
									<ul className="mt-1.5 list-disc space-y-1 pl-5 text-sm text-kaefer-dark-grey">
										{section.items.map((item) => (
											<li key={item}>{item}</li>
										))}
									</ul>
								</section>
							))}
						</div>
					</article>
				))}
			</div>
		</AdminCardPage>
	)
}
